import { render, staticRenderFns } from "./ProductsHub.vue?vue&type=template&id=52333450&"
import script from "./ProductsHub.vue?vue&type=script&lang=js&"
export * from "./ProductsHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports